module.exports = __webpack_public_path__ + "static/media/correct-IPV.f0480a2f.svg";